module.exports = __webpack_public_path__ + "static/PrayApp-463a7dce8f5f3c9c1308d3c61db15227.png";